import { useState } from 'react'

import { extend } from 'lodash-es'
// import ReactMarkdown from 'react-markdown'
//
// import rehypeRaw from 'rehype-raw'
// import remarkGfm from 'remark-gfm'
import simpleMarkdown from 'simple-markdown'

import style from './Simple.module.scss'

// import Link from '../Links'
//
// function LinkRenderer({ href = '', children = undefined }) {
//   if (href.match(/^\/[a-zA-Z0-9?=%/-]+$/)) {
//     return <Link to={href}>{children}</Link>
//   }
//   return (
//     <a href={href} target="_blank" rel="noopener noreferrer">
//       {children}
//     </a>
//   )
// }

const extLink = { target: '_blank', rel: 'noopener noreferrer' }

function error(content) {
  return { children: [content], href: '/' }
}

function rexMatch(s, rex) {
  return s.match(rex) !== null
}

function hasUrlPattern(href, title, isLocalPath) {
  if (isLocalPath) return false

  const hostname = new URL(href).hostname
  const t2 = title.replace(hostname, 'domain')

  // future: add in non-breakable spaces
  const hasUrlPattern = rexMatch(t2, /^[a-z0-9]+\s*\.[a-z0-9]+/i)

  if (hasUrlPattern) {
    return true
  }
  return false
}

function safeLinks(node, children) {
  const title = Array.from(reduce2text(node)).flat().join('')
  const href = simpleMarkdown.sanitizeUrl(node.target)

  const isLocalPath = rexMatch(href, /^\/[a-z0-9?=%/-]+$/i)

  if (title === href) {
    if (isLocalPath) {
      return { children, href }
    } else {
      return { children, href, ...extLink }
    }
  }

  try {
    if (hasUrlPattern(href, title, isLocalPath)) {
      return error(
        'possibly unsafe link in text, do not include a period with characters on both sides in the link name.'
      )
    }
    if (isLocalPath) {
      return { children, href }
    } else {
      return { children, href, ...extLink }
    }
  } catch (e) {
    console.log({ e, href })
    return error('cannot parse domain, link not made')
  }
}

function reduce2text({ content, type }) {
  if (type === 'text') {
    return content
  }
  return content.map(reduce2text)
}

const linkRule = { ...simpleMarkdown.defaultRules.link }
linkRule.react = function (node, output, state) {
  const children = output(node.content, state)
  const elem = safeLinks(node, children)

  // sanitize args
  // dom = new URL(sanitized)

  // const elem = {
  //   // href: sanitized,
  //   // title: node.title,
  //   // children: output(node.content, state),
  //   target: "_blank",
  //   rel: "noopener noreferrer"
  // }
  return simpleMarkdown.reactElement('a', state.key, elem)
}

////////////////////////////////////////////////////////////////////////////////
const spoilerRule = {
  order: simpleMarkdown.defaultRules.em.order - 0.5,
  match(source) {
    return /^\|\|([\s\S]+?)\|\|(?!\|)/.exec(source)
  },
  parse(capture, parse, state) {
    return { content: parse(capture[1], state) }
  },
  react(node, output, state) {
    return <Spoiler key={state.key}>{output(node.content, state)}</Spoiler>
  }
}

////////////////////////////////////////////////////////////////////////////////
const rules = extend({}, simpleMarkdown.defaultRules, {
  spoiler: spoilerRule,
  link: linkRule
})

const mdParserRaw = simpleMarkdown.parserFor(rules)
const mdOutput = simpleMarkdown.reactFor(
  simpleMarkdown.ruleOutput(rules, 'react')
)

function mdParse(source) {
  return mdParserRaw(source, { inline: false })
}

function Spoiler({ children }) {
  const [hide, showHide] = useState(true)
  return (
    <span className={hide ? style.sh : style.sv} onClick={() => showHide(!hide)}>
      {children}
    </span>
  )
}

function Markdown({
  children,
  className

  // safeLinks = true,
  // children,
  // components = {},
  // template = {},
  // ...props
}) {
  if (!children) return null
  const parsed = mdParse(children)
  return <div className={className}>{mdOutput(parsed)}</div>
}

// function updateTemplate(children, template) {
//   return Object.keys(template).reduce(
//     (children, key) => children.replaceAll(`{{${key}}}`, template[key]),
//     children
//   )
// }
//
export default Markdown
